<template>
  <div>
    <v-row justify="center">
      <v-col cols="12" md-5>
        <v-card class="mx-auto" width="400">
          <v-card-text>
            <v-row dense>
              <buscar-empleado class="mx-4" :value.sync="empSearch"></buscar-empleado>
            </v-row>
            <v-row dense class="mt-6 mb-3">
              <v-tooltip bottom activator="#btn-view">
                <span>Ver justificantes</span>
              </v-tooltip>
              <v-btn id="btn-view" :disabled="disabled" icon x-small @click="showJustiEmp = true">
                <v-icon>mdi-view-list-outline</v-icon>
              </v-btn>
              <span class="subtitle-2 ml-2 mr-4">{{nombreEmpleado}}</span>
            </v-row>
            <v-row dense>
                <v-col cols="4">
                    <v-select label="Ejercicio" :disabled="disabled" v-model="ejercicio" :items="ejercicios" dense></v-select>
                </v-col>
                <v-col cols="4">
                    <v-select label="Periodo" :disabled="disabled" v-model="periodo" :items="periodos" dense></v-select>
                </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="5">
                  <date-picker :disabled="disabled" label="Del" :date.sync="vigenciaIni" 
                    :alldays="true" :rules="[v => true]">
                  </date-picker>
              </v-col>
              <v-col cols="5">
                  <date-picker :disabled="disabled" label="Al" :date.sync="vigenciaFin" 
                    :alldays="true" :rules="[v => true]">
                  </date-picker>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="3">
                <v-text-field :disabled="disabled" label="Dias" v-model="dias" dense>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-textarea label="Motivo" v-model="motivo" :disabled="disabled" outlined rows="3" 
                  dense @input="valiMotivoLength($event)" counter="250" 
                  :rules="rulesMotivo" >
                </v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row justify="center">
              <v-btn :disabled="disabled" small outlined color="primary" @click="save()">
                <v-icon small left>
                  mdi-content-save-outline
                </v-icon>
                Guardar
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="showJustiEmp" persistent width="700">
      <v-card>
        <v-app-bar flat color="primary" class="white--text" dense>
          <v-toolbar-title>Justificantes</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon class="white--text" @click="showJustiEmp = false">mdi-close</v-icon>
        </v-app-bar>
        <v-card-text class="py-2">
          <span class="text-subtitle-1">{{nombreEmpleado}}</span>
          <justificantes-empleado :num-empleado="numEmpSearch" :reload="reloadJusti" :modo="modoAcceso" ></justificantes-empleado>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="showJustiEmp = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <dialog-message :show.sync="hndDlg.showDialog" :color="hndDlg.colorDlg" :title="hndDlg.titleDlg">
      {{ hndDlg.mensaje }}
    </dialog-message>
  </div>
</template>

<script>
  import DatePicker from "@/components/dialogs/DatePicker.vue";
  import hndDlg, {showInfo, showWarning, showError} from '@/components/dialogs/DialogHandler.js'
  import DialogMessage from "@/components/dialogs/DialogMessage.vue";
  import BuscarEmpleado from '@/components/dialogs/BuscarEmpleado.vue';
  import JustificantesEmpleado from '@/components/rh/justificantes/JustificantesEmpleado.vue';
  import serv from './AdelantarVacacionesServ.js';

  export default {
    components: {
      DatePicker,
      DialogMessage,
      BuscarEmpleado,
      JustificantesEmpleado
    },

    data() {
      return {
        nombreEmpleado: "",
        numEmpSearch: 0,
        empSearch: null,
        ejercicio: null,
        ejercicios: [],
        periodo: "1",
        periodos: ["1"],
        disabled: true,
        numEmplado: 0,
        vigenciaIni: null,
        vigenciaFin: null,
        dias: null,
        motivo: null,
        loading: false,
        hndDlg,
        overlay: false,
        rulesMotivo: [v => (!v || v.length <= 250) || 'Máximo 250 caracteres'],
        reloadJusti: false,
        showJustiEmp: false,
        modoAcceso: 'private'
      }
    },

    watch: {
      empSearch() {
        if (this.empSearch) {
          this.validaAcceso();
        }
      },
    },
    
    methods: {
      validaAcceso() {
        this.nombreEmpleado = "";
        this.numEmpSearch = 0;
        this.vigenciaIni = null;
        this.vigenciaFin = null;
        this.dias = null;
        this.motivo = null;
        this.disabled = true;

        serv.tieneAccesoInfEmpleado(this.empSearch.numEmpleado)
        .then(() => {
          this.disabled = false;
          this.nombreEmpleado = this.empSearch.nombreCompleto;
          this.numEmpSearch = this.empSearch.numEmpleado;
          this.empSearch = null;
          serv.loadPeriodosVac(this.numEmpSearch, this.modoAcceso);
        })
        .catch(error => {
          this.handleError(error, "No se pudo verificar información del empleado.");
        })
      },

      validaDias() {
        let ok = true;
        const numDias =  Number(this.dias);
        if (isNaN(numDias)) {
          ok = false;
          this.hndDlg = showWarning("Debe indicar un número en días.");
        } else {
          if (numDias <= 0) {
            ok = false;
            this.hndDlg = showWarning("Debe indicar el número de días.");
          }
        }
        return ok;
      },

      async save() {
        if (serv.validaSinDiasPeriodo(this.ejercicio, this.periodo)) {
          if (this.validaDias()) {
            const justiDto = this.createJustiDto();
            const justiVacDto = this.createJustiVacDto();
            this.overlay = true;
            try {
              const response = await serv.saveVacaciones(justiDto, justiVacDto, this.ejercicio);
              this.overlay = false;
              this.hndDlg = showInfo(response.data);
            }catch(error) {
              this.overlay = false;
              this.handleError(error, "No se pudo registrar el periodo vacacional.");
            }
          }
        } else {
          this.hndDlg = showWarning(serv.errorMessage);
        }
      },

      createJustiDto() {
        const justiDto = {
          numEmpleado: this.numEmpSearch,
          claveAdscArea: null,  //empleado.claveAdscFunc,
          tipoJustificante: 29,
          vigenciaIni: this.vigenciaIni,
          vigenciaFin: this.vigenciaFin,
          motivo: this.motivo,
          extemporaneo: false,
          serieLicMed: null,
          rango: 0, // Completo
          autorizaJefe: 0,
          dias: Number(this.dias),
          idEstatusJustificante: 3
        };
        return justiDto;
      },

      createJustiVacDto() {
        const justiVacDto = {
          idPeriodoVacaciones: 0,
          idJustificante: 29,
          dias: Number(this.dias),
          periodo: this.periodo
        };
        return justiVacDto;
      },

      valiMotivoLength(any) {
        if (any && any.length > 250 ) {
          this.showError("La lonjitud máxima del texto deben ser 250 caracteres.");
          this.$nextTick(() => {
            this.motivo = any.substr(0, 250);
          })
        }
      },

      handleError(error, mensaje) {
        if (error.response) {
          this.hndDlg = showError(error.response.data);
        } else {
          this.hndDlg = showError(mensaje);
        }
      },
    },

    mounted() {
      this.ejercicio = new Date().getFullYear();
      this.ejercicios = [this.ejercicio];
    }
  }
</script>